import { getErrorMessage } from '@mairistem/finances-utils';
import React from 'react';
import { toast } from 'react-toastify';
import TreeIndex from '../../../../classes/pieces/TreeIndex';
import TreeNodeType from '../../../../constants/liquidation/TreeNodeType';
import TreeRowKey from '../../../../constants/liquidation/TreeRowKey';
import type { TreeRow } from '../../../../interfaces/pieces/TreeRow';
import { getExercices } from '../../../../services/entites/exercices';
import useLiquidationTreeviewStore, {
	ROOT_LOADING_KEY,
} from '../../../../stores/liquidationTreeviewStore';

const { getState } = useLiquidationTreeviewStore;

/**
 * Charge les entités (racines de l'arbre) d'une année d'exercice, une seule fois : ensuite l'arbre est repris du
 * store, au retour d'une fiche comme au changement d'année.
 */
const useChargementRacines = (anneeExercice: number): void => {
	React.useEffect(() => {
		const arbre = getState().annees.get(anneeExercice);
		if (
			!arbre ||
			arbre.isRacinesChargees ||
			arbre.loadingKeys.has(ROOT_LOADING_KEY)
		) {
			return;
		}

		getState().setLoading(anneeExercice, ROOT_LOADING_KEY, true);
		getExercices(
			new URLSearchParams({
				anneeExercice: anneeExercice.toString(),
				withEntite: 'true',
				isActif: 'true',
			}),
		)
			.then(({ data: exercices }) => {
				const entites: TreeRow[] = exercices.map((exercice) => ({
					identifiant: exercice?.entite.identifiantEntite,
					libelle: exercice?.entite?.raisonSociale,
					rowKey: TreeRowKey.entite(exercice?.entite.identifiant),
					exercice,
					children: [],
					nodeType: TreeNodeType.ENTITE,
				}));
				getState().setRacines(anneeExercice, TreeIndex.fromRoots(entites));
			})
			.catch((error) => {
				toast.error(
					getErrorMessage(error, 'Erreur lors du chargement des entités'),
				);
			})
			.finally(() => {
				getState().setLoading(anneeExercice, ROOT_LOADING_KEY, false);
			});
	}, [anneeExercice]);
};

export default useChargementRacines;
